import React from "react";
import EditarProducto from "./EditarProducto";

const NuevoProducto = () => {
  return <EditarProducto edit={false} />;
};

export default NuevoProducto;
